// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--rrgBI","subtitle":"_93444fe79c--subtitle--tSF4C"};